"use client";

import { useEffect } from "react";

export function AosInit() {
  useEffect(() => {
    // 브라우저 환경에서만 실행
    if (typeof window !== "undefined") {
      Promise.all([import("aos"), import("aos/dist/aos.css")]).then(([Aos]) => {
        Aos.default.init({
          once: false, // 애니메이션을 한 번만 실행
          offset: -300,
          duration: 1000,
        });
      });
    }
  }, []);

  return null;
}
